'use strict';

var _      = require('underscore');
var $      = require('jquery');
var Core   = require('../core/core.js');

/**
 * Creates a Splash screen on startup
 *
 * @param {String} [options.target=body]
 * @class
 */

class WarningBanner extends Core {

	_defaults() {
		return {
			target: 'body',
            fields: {
                'message': 'Warning'
            }
		};
	}

	constructor(options) {
		super(options);

		this.template = `<div class='editor__warning__banner'>
                        <%- message %>
                        </div>`;

		super.render();

	}

}


module.exports = WarningBanner;
